import { createContext } from "react";

const GlobalDataContext = createContext();

export default GlobalDataContext;
